// Production config — auto-detects environment
const isProd = window.location.hostname !== 'localhost';
export const API_URL = isProd 
  ? 'https://api.papercrypto.app/api'
  : (process.env.REACT_APP_API_URL || 'http://localhost:5000/api');
export const WS_URL = isProd
  ? 'https://api.papercrypto.app'
  : (process.env.REACT_APP_WS_URL || 'http://localhost:5000');
export const API_ORIGIN = isProd
  ? 'https://api.papercrypto.app'
  : 'http://localhost:5000';
